import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";

export default class MapIntegrations extends CmsBaseClass {
    constructor(integrations) {
        super(integrations);

        this.wayfinding = this.mergeDefaults(this.wayfinding, {
            enabled: true,
            compass: false,
            gps: {
                enabled: false,
                ios: false,
                android: true
            },
            pedometer: false,
            qrCode: false,
            accessibilityNavigation: false
        });
        this.images360 = this.mergeDefaults(this.images360, {
            enabled: false,
            offsetAngle: 0
        });
    }

    isCompassEnabled() {
        return this.wayfinding.compass;
    }

    isGpsEnabled() {
        if (!this.wayfinding.gps.enabled) {
            return false;
        }

        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            return this.wayfinding.gps.ios;
        }

        if (/Android/i.test(navigator.userAgent)) {
            return this.wayfinding.gps.android;
        }

        return false;
    }

    isPedometerEnabled() {
        return this.wayfinding.pedometer && this.isGpsEnabled();
    }

    isQrCodeEnabled() {
        return this.wayfinding.qrCode;
    }

    isAccessibilityNavigationEnabled() {
        return this.wayfinding.accessibilityNavigation;
    }

    isImages360Enabled() {
        return this.images360.enabled;
    }
}
